import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-truncate',
  templateUrl: './truncate.component.html',
  styleUrls: ['./truncate.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
  standalone: true,
})
export class TruncateComponent {
  public static readonly VARIANTS: Variants = ['default', ['default', 'fade']];
  @ComponentVariant(TruncateComponent.VARIANTS)
  @Input()
  public variant: string;
}
